import React from 'react';

const VideoChatButton = props => {

    const classList = ["video-chat__btn"];
    let iconClass = props.btnOnClass;
    if (props.isOff) {
        classList.push("video-chat__btn video-chat__btn--off");
        iconClass = props.btnOffClass;
    }

    return (
        <button
            className={classList.join(' ')}
            onClick={props.clicked}
            disabled={props.disabled}
        >
            <i className={iconClass} aria-hidden="true"></i>
        </button>
    )

}

export default VideoChatButton;